import React from "react";
import { Navigate, Outlet, RouteObject } from "react-router-dom";

import HomePage from "pages/home/home.page";
import ContactUsPage from "pages/contact-us/contact-us.page";
import BrowseAppsPage from "pages/browse-apps/old_browse-apps.page";
// import DownloadCenterPage from "pages/download-center/download-center.page";

import MyProducts from "pages/myProducts/myProducts";
import Wishlist from "pages/wishlist/wishlist";
import WishListAddons from "pages/wishlist/wishListAddons";
import WishlistApplications from "pages/wishlist/wishlistApplications";
import LoginPage from "pages/login/login.page";
import RegistrationPage from "pages/registration/registration.page";
import NumberValidatePage from "pages/registration/number-validate.page";
import SecurityLoginPage from "pages/security-login/security-login.page";
import EmailPage from "pages/security-login/email.page";
import PhoneNumberPage from "pages/security-login/phone.page";
import ChangePasswordPage from "pages/security-login/change-password.page";

import AppDetailPage from "pages/details/app-detail.page";
import AddonDetailPage from "pages/details/addon-detail.page";
import ModuleDetailPage from "pages/details/module-detail.page";
import AccountDataPage from "pages/registration/account-data.page";
import PaymentPage from "pages/payment/payment.page";
import PricingPlans from "pages/pricing-plans/pricing-plans";
import PaymentDetails from "pages/payment-details/payment-details";
import PaymentSetting from "pages/paymentSetting/paymentSetting";
import AccountPage from "pages/account/account.page";
import ProfileInfoPage from "pages/account/profile-info.page";
import AccountSettingsPage from "pages/account/account-settings.page";
import MyApps from "pages/myApps/myApps";
import BlockedMobilePage from "pages/informations/blocked-mobile.page";
import EmailVerificationPage from "pages/informations/email-verification.page";
import LinkSentPage from "pages/informations/link-sent.page";
import LinkExpiredPage from "pages/informations/link-expired.page";
import CongratulationPage from "pages/informations/congratulation.page";
import LicensesPage from "pages/myApps/pages/licenses.page";
import Addons from "pages/myApps/pages/addons";
import Releases from "pages/myApps/pages/releases";
import Manage from "pages/myApps/pages/manage";
import AddonDetailsMange from "pages/myApps/pages/addonDetailsMange";
import BlockedEmailPage from "pages/informations/blocked-email.page";
import PrivateRouteComponent from "components/private-route/private-route.component";
import { useAuthContext } from "store/auth";
import ForgotPasswordPage from "pages/password/forgot-password.page";
import ResetPasswordPage from "pages/password/reset-password.page";
import InvoicesPage from "pages/invoices/invoices.page";
import TicketsPage from "pages/tickets/tickets.page";
import Terms from "pages/terms/terms";
import CanLoadGuard from "components/private-route/can-load.guard";
import UnpaidInvoicePage from "pages/invoices/pages/unpaid.page";
import PaidInvoicePage from "pages/invoices/pages/paid.page";
import RefundedInvoicePage from "pages/invoices/pages/refunded.page";
import CanceledInvoicePage from "pages/invoices/pages/canceled.page";
import DownloadCenterNew from "pages/download-center-new/downloadCenterNew";
import FawryCard from "pages/payment-details/fawry-card";
import ChangeRequests from "pages/myApps/pages/changeRequests";
import TempRegister from "pages/temp-register";
import TempNumberValidatePage from "./pages/temp-register/temp-phone-validate";

const RouteToHomeWhenLoggedIn = ({ component: Component }: { component: React.FC }) => {
  const [{ isLoggedIn }] = useAuthContext();
  if (isLoggedIn) return <Navigate to="/" />;
  return <Component />;
};

export const appRoutes: RouteObject[] = [
  { path: "", element: <HomePage /> },
  { path: "download-center", element: <DownloadCenterNew /> },
  { path: "contact-us", element: <ContactUsPage /> },
  {
    path: "browse-apps",
    element: (
      <CanLoadGuard isPage>
        <PrivateRouteComponent component={BrowseAppsPage} />
      </CanLoadGuard>
    )
  },
  { path: "addon-details/:id", element: <PrivateRouteComponent component={AddonDetailPage} /> },
  { path: "app/:id", element: <PrivateRouteComponent component={AppDetailPage} /> },
  { path: "module/:id", element: <PrivateRouteComponent component={ModuleDetailPage} /> },
  { path: "payment", element: <PrivateRouteComponent component={PaymentPage} /> },
  { path: "login", element: <RouteToHomeWhenLoggedIn component={LoginPage} /> },
  { path: "forget-password", element: <RouteToHomeWhenLoggedIn component={ForgotPasswordPage} /> },
  { path: "reset-password/:token", element: <ResetPasswordPage /> },

  // {
  //   path: "register",
  //   element: <RouteToHomeWhenLoggedIn component={ () => <Outlet />} />,
  //   children: [
  //     { path: "", element: <RegistrationPage /> },
  //     { path: "validate-number", element: <NumberValidatePage /> },
  //     { path: "account-data", element: <AccountDataPage /> },
  //   ],
  // },

  { path: "my-products", element: <PrivateRouteComponent component={MyProducts} /> },

  {
    path: "Wishlist",
    element: <PrivateRouteComponent component={Wishlist} />,
    children: [
      { path: "", element: <WishlistApplications /> },
      { path: "addons", element: <WishListAddons /> }
    ]
  },

  { path: "/security/email/:token", element: <EmailVerificationPage fallback="/security/email" toURL="/security/email" /> },

  {
    path: "security",
    element: <PrivateRouteComponent component={SecurityLoginPage} />,
    children: [
      { path: "", element: <Navigate to="email" /> },
      { path: "email", element: <EmailPage /> },
      { path: "Phone", element: <PhoneNumberPage /> },
      {
        path: "change-password",
        element: (
          <CanLoadGuard isPage>
            <ChangePasswordPage />
          </CanLoadGuard>
        )
      }
    ]
  },

  {
    path: "info",
    children: [
      {
        path: "blocked-mobile",
        element: <BlockedMobilePage />
      },
      {
        path: "link-sent",
        element: <LinkSentPage />
      },
      { path: "link-expired", element: <LinkExpiredPage /> },
      { path: "blocked-email", element: <BlockedEmailPage /> },
      { path: "congratulations", element: <CongratulationPage /> }
    ]
  },

  {
    path: "verify/:token",
    caseSensitive: false,
    element: <EmailVerificationPage />
  },

  {
    path: "account",
    element: <PrivateRouteComponent component={AccountPage} />,
    children: [
      { path: "", element: <Navigate to="profile-info" /> },
      { path: "profile-info", element: <ProfileInfoPage /> },
      { path: "account-settings", element: <AccountSettingsPage /> }
    ]
  },

  { path: "payment-details/*", element: <PrivateRouteComponent component={PaymentDetails} /> },
  { path: "fawry-card/*", element: <PrivateRouteComponent component={FawryCard} /> },
  { path: "pricing-plans/:id", element: <PrivateRouteComponent component={PricingPlans} /> },
  { path: "paymentSetting", element: <PrivateRouteComponent component={PaymentSetting} /> },
  {
    path: "my-apps/:id",
    element: <PrivateRouteComponent component={MyApps} />,
    children: [
      { path: "", element: <Navigate to="licenses?device" /> },
      { path: "licenses/*", element: <LicensesPage /> },
      { path: "addons", element: <Addons /> },
      { path: "releases", element: <Releases /> },
      { path: "changeRequests", element: <ChangeRequests /> },
      {
        path: "manage",
        element: (
          <CanLoadGuard isPage>
            <Manage />
          </CanLoadGuard>
        )
      }
    ]
  },
  {
    path: "invoices",
    element: <PrivateRouteComponent component={InvoicesPage} />,
    children: [
      { path: "", element: <Navigate to="unpaid" /> },
      { path: "unpaid", element: <UnpaidInvoicePage /> },
      { path: "paid", element: <PaidInvoicePage /> },
      { path: "refunded", element: <RefundedInvoicePage /> },
      { path: "canceled", element: <CanceledInvoicePage /> }
    ]
  },

  { path: "addon-license/:id", element: <PrivateRouteComponent component={AddonDetailsMange} /> },
  { path: "tickets", element: <PrivateRouteComponent component={TicketsPage} /> },
  { path: "tickets/:ticketSerial", element: <PrivateRouteComponent component={TicketsPage} /> },
  { path: "terms", element: <Terms /> },

  { path: "temp-register", element: <RouteToHomeWhenLoggedIn component={TempRegister} /> },
  { path: "/temp-validate", element: <RouteToHomeWhenLoggedIn component={TempNumberValidatePage} /> }
];
